var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSplashRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 35,
    viewBox: "0 0 20 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M10.86 28.3935C12.0784 29.9324 11.8695 32.2718 10.3938 33.6182C8.91795 34.9648 6.73376 34.8089 5.51536 33.2699C3.30921 30.4834 2.6723 23.8655 2.6723 23.8655C2.6723 23.8655 8.65382 25.607 10.86 28.3935Z",
    fill: "#2A7DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M10.86 6.93385C12.0784 5.39493 11.8695 3.05557 10.3938 1.70912C8.91795 0.362547 6.73376 0.518479 5.51536 2.0574C3.30921 4.84391 2.6723 11.4619 2.6723 11.4619C2.6723 11.4619 8.65382 9.72036 10.86 6.93385Z",
    fill: "#2A7DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M14.4487 13.9001C16.3308 13.9001 17.8565 15.5853 17.8565 17.6637C17.8565 19.7422 16.3308 21.4272 14.4487 21.4272C11.0409 21.4272 5.9292 17.6637 5.9292 17.6637C5.9292 17.6637 11.0409 13.9001 14.4487 13.9001Z",
    fill: "#2A7DFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplashRight);
export default __webpack_public_path__ + "static/media/splashRight.ac7b1e0ef17a1b1105d7f2b581d885fc.svg";
export { ForwardRef as ReactComponent };